import { render } from "./DialogSDColorList.vue?vue&type=template&id=270578ac"
import script from "./DialogSDColorList.vue?vue&type=script&lang=js"
export * from "./DialogSDColorList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__